// @flow

import type {CheckedTree, CheckedTreeItem} from '../typedef';

export const getCheckedChildrenState =
    (total: number | boolean, checked: number | boolean, children?: CheckedTree): CheckedTreeItem => {
        let item = {indeterminate: false};

        if (checked || children && Object.keys(children).length) {
            item = {
                ...item,
                ...(checked !== total ? {indeterminate: true} : {}),
                ...(children ? {children} : {})
            };
        }
        return item;
    };
